/**
 * Returns a new Date object set to X days ago from today
 */
const getDaysAgo = (days: number): Date => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    date.setMinutes(0, 0, 0);
    return date;
};

export const TODAYS_DATE = new Date(new Date().setHours(0, 0, 0, 0)).getTime(); // Start of today

// More like 28 hours ago but w/e
// export const ONE_DAY_AGO = new Date(new Date().getTime() - 28 * 60 * 60 * 1000);

export const SEVEN_DAYS_AGO = getDaysAgo(7);

export const TWO_WEEKS_AGO = getDaysAgo(14);

export const THIRTY_DAYS_AGO = getDaysAgo(30);

export const SIXTY_DAYS_AGO = getDaysAgo(60);

export const NINETY_DAYS_AGO = getDaysAgo(90);

export const SIX_MONTHS_AGO = getDaysAgo(180);

export const THREE_QUARTERS_AGO = getDaysAgo(270);

export const ONE_YEAR_AGO = getDaysAgo(365);

export const THREE_YEARS_AGO = getDaysAgo(365 * 3);

export const TWO_YEARS_AGO = getDaysAgo(365 * 2).getTime(); // Approximately 24 months ago

export const FOUR_YEARS_AGO = getDaysAgo(365 * 4).getTime(); // Approximately 48 months ago
